module.exports = __webpack_public_path__ + "static/media/1POLICY10.d950b234.jpg";